export default __webpack_public_path__ + "static/char-s-39-zh-Hant-a7bba7db3a82c8fb0ebc8dc83bf99654.png";